import SignatureGenerator from './SignatureGenerator';

function App() {
	return (
		<div className="App">
			<SignatureGenerator />
		</div>
	);
}

export default App;
